// QiblaMap.js

import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Polyline } from 'react-leaflet';
import './Qibla.css';

const QiblaMap = () => {
  const [userLocation, setUserLocation] = useState(null);
  const [qiblaDirection, setQiblaDirection] = useState(null);

  useEffect(() => {
    // Fetch user's location and Qibla direction
    // ...

    // For demonstration purposes, setting example data
    setUserLocation({ lat: 40.7128, lng: -74.0060 }); // Example: New York City
    setQiblaDirection(51.1846025); // Example Qibla direction
  }, []);

  // Function to calculate Qibla position based on user's location and Qibla direction
  const calculateQiblaPosition = (userLocation, qiblaDirection) => {
    const qiblaDistance = 0.01; // Adjust as needed
    const qiblaLat = userLocation.lat + qiblaDistance * Math.cos(toRadians(qiblaDirection));
    const qiblaLng = userLocation.lng + qiblaDistance * Math.sin(toRadians(qiblaDirection));
    return { lat: qiblaLat, lng: qiblaLng };
  };

  // Helper function to convert degrees to radians
  const toRadians = (degrees) => {
    return degrees * (Math.PI / 180);
  };

  return (
    <div className="qibla-map-container">
      <MapContainer center={userLocation} zoom={13} className="qibla-map">
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        {userLocation && <Marker position={userLocation} />}
        {qiblaDirection && (
          <Polyline
            positions={[userLocation, calculateQiblaPosition(userLocation, qiblaDirection)]}
            className="qibla-polyline"
          />
        )}
      </MapContainer>
      {userLocation && <div className="qibla-marker" />}
    </div>
  );
};

export default QiblaMap;
